import React, { useState } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import {
    hideSearchAIPrompt,
    setSearchInputValue,
    showSearchResults,
    fetchSearchResults,
    resetSearchAI,
} from '../searchAIPromptActions'
import SearchAIPrompt from '../components/SearchAIPrompt'

const SearchAIPromptContainer = ({
    showSearchAIPrompt,
    hideSearchAIPrompt,
    setSearchInputValue,
    searchInputValue,
    resetSearchAI,
    isDeviceMobile,
    searchAIStops,
    showResults,
    fetchSearchResults,
    stopsToPoints,
    tour,
}) => {
    const [hasFetched, setHasFetched] = useState(false)

    const handleOnClose = () => {
        hideSearchAIPrompt()
        // want to clear search results when user closes the search AI prompt after search is completed
        if (hasFetched) resetSearchAI()
    }

    const handleInputClick = e => {
        e.stopPropagation()
    }

    const handleChange = e => {
        setSearchInputValue(e.target.value)
    }

    const handleSearchClick = e => {
        e.stopPropagation()
        if (searchInputValue.length > 0) {
            fetchSearchResults({ locId: tour.loc_id, tourId: tour.tourid, stopsToPoints })
            setHasFetched(true)
        }
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            handleSearchClick(e)
        }
    }

    const handleClearClick = e => {
        e.stopPropagation()
        if (searchInputValue.length > 0) {
            setSearchInputValue('')
        }
    }

    return (
        <SearchAIPrompt
            onClick={handleOnClose}
            onInputClick={handleInputClick}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            onSearchClick={handleSearchClick}
            onClearClick={handleClearClick}
            showSearchAIPrompt={showSearchAIPrompt}
            searchInputValue={searchInputValue}
            isDeviceMobile={isDeviceMobile}
            showResults={showResults}
            results={searchAIStops}
        />
    )
}

export default compose(
    connect(
        mapSelectorsToProps([
            'tour',
            'showSearchAIPrompt',
            'searchInputValue',
            'searchAIStops',
            'isDeviceMobile',
            'showResults',
            'stopsToPoints',
        ]),
        {
            hideSearchAIPrompt,
            setSearchInputValue,
            showSearchResults,
            fetchSearchResults,
            resetSearchAI,
        }
    )
)(SearchAIPromptContainer)
